module.exports = __webpack_public_path__ + "img/diesel.1e6dad9e.svg";